import {Expose} from 'class-transformer';

export class PickupTimeStatusResponseModel {

  @Expose()
  status: number;
}
